var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.996 9C12.1331 9 12.2596 9.02619 12.3755 9.07858C12.4914 9.13098 12.6021 9.20956 12.7075 9.31434L16.7312 13.4361C16.9104 13.609 17 13.8238 17 14.0805C17 14.2482 16.9578 14.4027 16.8735 14.5442C16.7945 14.6857 16.6838 14.7983 16.5415 14.8821C16.4045 14.9607 16.2516 15 16.083 15C15.83 15 15.6061 14.9057 15.4111 14.7171L11.996 11.2004L8.58103 14.7171C8.38603 14.9057 8.16469 15 7.917 15C7.74308 15 7.58762 14.9607 7.45059 14.8821C7.31357 14.7983 7.20553 14.6857 7.12648 14.5442C7.04216 14.4028 7 14.2482 7 14.0806C7 13.8238 7.08696 13.609 7.26087 13.4361L11.2846 9.31434C11.39 9.20956 11.5007 9.13098 11.6166 9.07858C11.7325 9.02619 11.859 9 11.996 9Z",
    fill: "#03122E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/ChevronUp.25cfc0375de9102a26211e554fd09e7c.svg";
export { ForwardRef as ReactComponent };